import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {URLHelper} from 'helpers/url.helper';
import {DataService} from '../data-service';
import {DataListHelper} from 'helpers/data-list.helper';

@Injectable()
export class ReportDataService extends DataService {

  getParkingUsages(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any, sortFilter?: any, isOnlyShowOverStay?: Boolean): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string', 'phoneNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/usages/search?', options.query, '');

    let sortedType = '&sort=updatedDate,desc';
    if (sortFilter != null) {
      sortedType = '&sort=' + sortFilter;
    }

    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (isOnlyShowOverStay === true) {
      url = url + `,(isOverStay==true)`;
    }

    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + `;(usageType==GATE);(usageStatus!=CANCELLED)` + sortedType);
  }

  requestUsagesExcel(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any, subscribersId?: any, sortFilter?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    let sortedType = '';
    if (sortFilter != null) {
      sortedType = '&sort=' + searchFilter;
    }


    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';

    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/usages/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (searchPayment) {
      url = url + `;(paymentMethod==${searchPayment})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usages/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')' + sortedType), '', options);
    } else {
      url = url + ';(usageStatus!=CANCELLED)' + sortedType;
    }

    return this.requestExportReport('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestUsagesPDF(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';

    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/usages/export-pdf?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (searchPayment) {
      url = url + `;(paymentMethod==${searchPayment})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usages/export-pdf?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    } else {
      url = url + ';(usageStatus!=CANCELLED)';
    }

    return this.requestExportReport('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestParkingLotUsageSummaryExcelByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-excel-daily?', '', options);
  }

  requestParkingLotUsageSummaryPDFByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-pdf-daily?', '', options);
  }

  requestParkingLotUsageSummaryExcelByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-excel-monthly?', '', options);
  }

  requestParkingLotUsageSummaryPDFByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-pdf-monthly?', '', options);
  }

  requestParkingLotUsageSummaryExcelByAnnually(options: any, year?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (year) {
      options.params = {year: year};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-excel-annually?', '', options);
  }

  requestParkingLotUsageSummaryPDFByAnnually(options: any, year?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (year) {
      options.params = {year: year};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/usage-summary/export-pdf-annually?', '', options);
  }

  getParkingLotBookings(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/bookings/search?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (searchPayment) {
      url = url + `;(paymentMethod==${searchPayment})`;
    }
    return this.get('', {'parking-lots': 'PARKING_LOT_ID'}, url + `&sort=createdDate,desc`);
  }

  getParkingLotStaffCutOff(options: any, cutoffDate: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    let url: string = URLHelper.buildQueryString('/staff-cutoffs?', options.query, '');
    if (cutoffDate) {
      url += `&query=with=all=1;(cutoffDate>="${cutoffDate}")`;
    }
    return this.get('', {'parking-lots': 'PARKING_LOT_ID'}, url + '&sort=createdDate,desc');
  }

  requestParkingLotStaffCutOffExcel(options: any, searchFilter: any, searchCategory: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    let url: string = URLHelper.buildQueryString('/staff-cutoffs/export-excel?', options.query, '');
    url = url + '&query=';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `(paidTime>="${searchRangeDate.start}";paidTime<="${searchRangeDate.end}")`;
      if (searchCategory) {
        url = url + ';';
      }
    }
    if (searchCategory) {
      url = url + `(paymentMethod==${searchCategory})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/staff-cutoffs/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }

    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestParkingLotStaffCutOffPDF(options: any, searchFilter: any, searchCategory: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    let url: string = URLHelper.buildQueryString('/staff-cutoffs/export-pdf?', options.query, '');
    url = url + '&query=';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `(paidTime>="${searchRangeDate.start}";paidTime<="${searchRangeDate.end}")`;
      if (searchCategory) {
        url = url + ';';
      }
    }
    if (searchCategory) {
      url = url + `(paymentMethod==${searchCategory})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/staff-cutoffs/export-pdf?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }

    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  getParkingInvoices(options: any, searchFilter: any, searchCategory: string, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};

    let url: string = URLHelper.buildQueryString('/invoice-usages/search?', options.query, '');
    url = url + '&query=';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `(paidTime>="${searchRangeDate.start}";paidTime<="${searchRangeDate.end}")`;
      if (searchCategory) {
        url = url + ';';
      }
    }
    if (searchCategory) {
      url = url + `(paymentMethod==${searchCategory})`;
    }

    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + '&sort=paidTime,desc');
  }

  requestInvoicesExcel(options: any, searchFilter: any, searchCategory: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    let url: string = URLHelper.buildQueryString('/invoice-usages/export-excel?', options.query, '');
    url = url + '&query=';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `(paidTime>="${searchRangeDate.start}";paidTime<="${searchRangeDate.end}")`;
      if (searchCategory) {
        url = url + ';';
      }
    }
    if (searchCategory) {
      url = url + `(paymentMethod==${searchCategory})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-usages/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }

    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestInvoicesPDF(options: any, searchFilter: any, searchCategory: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    let url: string = URLHelper.buildQueryString('/invoice-usages/export-pdf?', options.query, '');
    url = url + '&query=';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `(paidTime>="${searchRangeDate.start}";paidTime<="${searchRangeDate.end}")`;
      if (searchCategory) {
        url = url + ';';
      }
    }
    if (searchCategory) {
      url = url + `(paymentMethod==${searchCategory})`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-usages/export-pdf?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }

    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestInvoiceSummaryExcelByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-summary/export-excel-daily?', '', options);
  }

  requestInvoiceSummaryPDFByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-summary/export-pdf-daily?', '', options);
  }

  requestInvoiceSummaryExcelByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-summary/export-excel-monthly?', '', options);
  }

  requestInvoiceSummaryPDFByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/invoice-summary/export-pdf-monthly?', '', options);
  }

  getParkingBarricadeUsages(options: any, searchFilter: any, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'user': 'string', 'description': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/events/search?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `;(eventDate>="${searchRangeDate.start}";eventDate<="${searchRangeDate.end}")`;
    }

    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + '&sort=createdDate,desc');
  }

  requestParkingBarricadeUsagesExcel(options: any, searchFilter: any, searchRangeDate?: any, parkingBarricadeUsagesIds?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';

    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'user': 'string', 'description': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/events/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `;(eventDate>="${searchRangeDate.start}";eventDate<="${searchRangeDate.end}")`;
    }

    if (parkingBarricadeUsagesIds) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/events/export-excel?limit=' + (parkingBarricadeUsagesIds.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((parkingBarricadeUsagesIds.length == 0) ? 'out=(-1)' : 'in=(' + parkingBarricadeUsagesIds.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestParkingBarricadeUsagesPDF(options: any, searchFilter: any, searchRangeDate?: any, parkingBarricadeUsagesIds?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';

    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'user': 'string', 'description': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/events/export-pdf?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      url = `${url}` + `;(eventDate>="${searchRangeDate.start}";eventDate<="${searchRangeDate.end}")`;
    }

    if (parkingBarricadeUsagesIds) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/events/export-pdf?limit=' + (parkingBarricadeUsagesIds.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((parkingBarricadeUsagesIds.length == 0) ? 'out=(-1)' : 'in=(' + parkingBarricadeUsagesIds.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  getParkingLiftUsages(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/usages/lift?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (searchPayment) {
      url = url + `;(paymentMethod==${searchPayment})`;
    }
    return this.get('', {'parking-lots': 'PARKING_LOT_ID'}, url + `;(usageType==LIFT)&sort=createdDate,desc`);
  }

  getParkingSpaceUsages(options: any, searchFilter: any, searchCategory?: string, searchPayment?: any, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/locker-usage/search?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + `;(usageType==LOCKER);(usageStatus!=CANCELLED)`);
  }

  getPrivilegeZoneUsages(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string', 'phoneNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/privilege-zone-usages/search?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + `;(usageType==GATE)&sort=createdDate,desc`);
  }

  requestPrivilegeZoneUsagesExcel(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/privilege-zone-usages/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-usages/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestPrivilegeZoneUsagesPDF(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/privilege-zone-usages/export-pdf?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-usages/export-pdf?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestSummaryPrivilegeZoneUsagesExcelByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-summary/export-excel-daily?', '', options);
  }

  requestSummaryPrivilegeZoneUsagesPDFByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-summary/export-pdf-daily?', '', options);
  }

  requestSummaryPrivilegeZoneUsagesExcelByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-summary/export-excel-monthly?', '', options);
  }

  requestSummaryPrivilegeZoneUsagesPDFByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/privilege-zone-summary/export-pdf-monthly?', '', options);
  }

  requestOvernightUsagesExcelByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-excel-daily?', '', options);
  }

  requestOvernightUsagesPDFByDaily(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-pdf-daily?', '', options);
  }

  requestOvernightUsagesExcelByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-excel-monthly?', '', options);
  }

  requestOvernightUsagesPDFByMonthly(options: any, searchRangeDate?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end) {
      options.params = {startDate: searchRangeDate.start, endDate: searchRangeDate.end};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-pdf-monthly?', '', options);
  }

  requestOvernightUsagesExcelByAnnually(options: any, year?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (year) {
      options.params = {year: year};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-excel-annually?', '', options);
  }

  requestOvernightUsagesPDFByAnnually(options: any, year?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    if (year) {
      options.params = {year: year};
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overnight-summary/export-pdf-annually?', '', options);
  }

  getParkingOverTimeUsages(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/overdue-usages/search?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    return this.get('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url + `;(usageType==GATE)&sort=createdDate,desc`);
  }

  requestOverTimeUsagesExcel(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/overdue-usages/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overdue-usages/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestOverTimeUsagesPDF(options: any, searchFilter: any, searchCategory?: string, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/pdf');
    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'licensePlateLetter': 'string', 'licensePlateProvince': 'string', 'licensePlateNumber': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/overdue-usages/export-pdf?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }
    if (searchCategory) {
      url = url + `;(parkingType==${searchCategory})`;
    }
    if (searchCategory == 'MEMBER' || searchCategory == 'PRE_REGISTER_VISITOR') {
      url = url + `,(parkingType==SUBSCRIBER)`;
    }
    if (searchCategory == 'VISITOR') {
      url = url + `,(parkingType==TEMPORARY)`;
    }
    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/overdue-usages/export-pdf?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length == 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }

  requestBluelockUsagesExcel(options: any, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';


    let url: string = URLHelper.buildQueryString('/locker-usages/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/locker-usages/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length === 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);


  }

  requestBluelockBookingExcel(options: any, searchRangeDate?: any, subscribersId?: any): Promise<any> {
    const header = new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('mimeType', 'application/vnd.ms-excel');

    options = options || {};
    options.headers = header;
    options.responseType = 'blob';
    options.observe = 'response';


    let url: string = URLHelper.buildQueryString('/locker-bookings/export-excel?', options.query, '');
    if (searchRangeDate && searchRangeDate.start && searchRangeDate.end && searchRangeDate.title) {
      url = `${url};` + `(${searchRangeDate.title}>="${searchRangeDate.start}";${searchRangeDate.title}<="${searchRangeDate.end}")`;
    }

    if (subscribersId) {
      return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, '/locker-bookings/export-excel?limit=' + (subscribersId.length || DataListHelper.MAXIMUN_QUERYABLE_ROW_COUNT) +
        '&query=id=' + ((subscribersId.length === 0) ? 'out=(-1)' : 'in=(' + subscribersId.join(',') + ')'), '', options);
    }
    return this.post('reports/', {'parking-lots': 'PARKING_LOT_ID'}, url, '', options);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/report/report.service.ts